import { render, staticRenderFns } from "./Traits.vue?vue&type=template&id=3ffe6251&"
import script from "./Traits.vue?vue&type=script&lang=js&"
export * from "./Traits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports